import React from "react";
import PropTypes from "prop-types";
import constant from "./utils/constant";
import { CircleWithIcon } from "./Common";
import { AttachIcon } from "../../images";
import Processing from "./Proccessing";

const AttachBox = (props) => {
  const {
    attaching,
    processing,
    handleAttachChangeInput,
    loadedSize,
    totalSize,
    percentComplete,
  } = props;
  const back_color = constant.COLOR.BACK_COLOR_OF_CIRCLE_HAS_ICON;


  if (processing) {
    return (
      <Processing
        attaching={attaching}
        percentComplete={percentComplete}
        loadedSize={loadedSize}
        totalSize={totalSize}
        backColor={back_color.ACTIVE_ATTACH}
      />
    );
  }
  return (
    <div className="initial-state attach">
      <form
        action={constant.API.SERVER_TRANSCRIBE_URl}
        id="upload_form"
        method="post"
      >
        <input
          type="file"
          hidden={true}
          id="file_input"
          name="media"
          onChange={handleAttachChangeInput}
        />
        <label id="file_label" htmlFor="file_input">
          <CircleWithIcon
            backColor={back_color.ACTIVE_ATTACH}
            ChildComponent={AttachIcon}
            classNames="icon-wrapper attach-icon"
          />
        </label>
        <div className="text">
          <div className="in-web">
            <div>
              برای بارگذاری فایل گفتاری (صوتی/تصویری)، دکمه را فشار دهید
            </div>
            <div>متن پیاده شده آن، در اینجا ظاهر می شود</div>
          </div>
          <div className="in-mobile">
            <div>برای بارگذاری فایل گفتاری (صوتی/تصویری)،</div>
            <div>دکمه را فشار دهید</div>
          </div>
        </div>
      </form>
    </div>
  );
};

AttachBox.propTypes = {
  processing: PropTypes.bool,
  attaching: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  handleAttachChangeInput: PropTypes.func.isRequired,
};

// Set default props
AttachBox.defaultProps = {
  processing: false,
  attaching: false,
};

export default AttachBox;
